export default function PHP_getdate() {
  return (
    <div>
      <h1>PHP_getdate</h1>
    </div>
  );
}
